import React from 'react';
import CorrelationWidgetRenderer from './CorrelationWidgetRenderer';

const Preview: React.FC = () => (
  <CorrelationWidgetRenderer config={{}} />
);

export default Preview;
